import * as Sentry from "@sentry/nextjs";

type HttpResponse = { status?: number };

export async function withHttpSpan<T extends HttpResponse>(
  method: "get" | "post",
  url: string,
  request: () => Promise<T>,
): Promise<T> {
  const hub = Sentry.getCurrentHub();
  const parentTransaction = hub.getScope()?.getTransaction();
  const description = `${method.toUpperCase()} ${url}`;

  if (parentTransaction) {
    const span = parentTransaction.startChild({
      op: "http.client",
      description,
    });

    try {
      const result = await request();
      if (result?.status) {
        span.setHttpStatus(result.status);
      }
      return result;
    } catch (error) {
      span.setStatus("internal_error");
      throw error;
    } finally {
      span.finish();
    }
  }

  const transaction = Sentry.startTransaction({
    name: description,
    op: "http.client",
  });

  hub.configureScope((scope) => scope.setSpan(transaction));

  try {
    const result = await request();
    if (result?.status) {
      transaction.setHttpStatus(result.status);
    }
    return result;
  } catch (error) {
    transaction.setStatus("internal_error");
    throw error;
  } finally {
    transaction.finish();
  }
}
